import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { accentText } from "@/lib/text";

const FALLBACK = [
  { q: "How long does it take to get my custom song?", a: "Most songs land in your inbox within 12 hours. If a detail is unclear, our team reaches out on your email or WhatsApp before we start." },
  { q: "What info do I need to provide in the order form?", a: "Just who the song is for, the occasion, and a few memories or inside jokes. The more specific you are, the more personal it feels — but even a few lines works." },
  { q: "Can I choose the music style and singer?", a: "Yes — pick from acoustic, soulful, romantic pop, lo-fi, indie folk and more, plus male, female or duet vocals, in English, Hindi, Hinglish or Spanish." },
  { q: "What if I need minor edits to the lyrics?", a: "No problem. Reply to your delivery email and our team will make it right." },
  { q: "How is the final song delivered?", a: "By email: a studio-quality MP3 download plus a printable lyric-card PDF and the full lyrics. Yours forever." },
  { q: "How do I pay?", a: "One secure checkout payment at the end of the order form — cards, UPI and netbanking. No subscription, no hidden fees." },
];

export default function Faq({ content }) {
  const faqs = content?.faqs?.length ? content.faqs : FALLBACK;
  return (
    <section id="faq" className="py-20 sm:py-28 scroll-mt-24" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }} className="text-center">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-pink font-semibold mb-4">{content?.faq_eyebrow ?? "Questions, answered"}</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.1]">
            {accentText(content?.faq_heading ?? "Everything you're ~wondering~", "text-tangerine")}
          </h2>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: 0.1 }} className="mt-12">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-accordion-item-${i}`}
                className={`rounded-2xl bg-white border-[3px] border-ink shadow-[4px_4px_0_#2D1A32] px-6 ${i % 2 ? "rotate-[0.5deg]" : "rotate-[-0.5deg]"}`}>
                <AccordionTrigger className="text-left font-display font-semibold text-lg hover:no-underline py-5">{f.q}</AccordionTrigger>
                <AccordionContent className="text-sm text-plum font-medium leading-relaxed pb-5">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
